import React, { useRef, useState } from 'react';
import { beforeAfterItems, transformBg } from '../mock';

const BeforeAfter = () => {
  const [activeIdx, setActiveIdx] = useState(0);
  const [pos, setPos] = useState(50);
  const stageRef = useRef(null);
  const draggingRef = useRef(false);
  const item = beforeAfterItems[activeIdx];

  const updatePos = (clientX) => {
    if (!stageRef.current) return;
    const rect = stageRef.current.getBoundingClientRect();
    const x = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, x)));
  };

  const onDown = (e) => {
    draggingRef.current = true;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    updatePos(clientX);
  };
  const onMove = (e) => {
    if (!draggingRef.current) return;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    updatePos(clientX);
  };
  const onUp = () => { draggingRef.current = false; };

  return (
    <section
      id="oncesi-sonrasi"
      className="section"
      style={{ backgroundColor: 'var(--bg-2)' }}
    >
      <div className="section-bg" style={{ backgroundImage: `url(${transformBg})`, opacity: 0.05 }} />
      <div className="section-inner">
        <div className="section-head">
          <div className="section-label">Öncesi & Sonrası</div>
          <h2 className="section-title">
            Dönüşümü Kendiniz <br />
            <span className="accent">Görün</span>
          </h2>
        </div>
        <div className="ba-tabs">
          {beforeAfterItems.map((b, i) => (
            <button
              key={b.id}
              className={`ba-tab ${i === activeIdx ? 'active' : ''}`}
              onClick={() => { setActiveIdx(i); setPos(50); }}
            >
              {b.label}
            </button>
          ))}
        </div>
        <div className="ba-helper">Kaydırıcıyı sürükleyerek karşılaştırın</div>
        <div
          className="ba-stage"
          ref={stageRef}
          onMouseDown={onDown}
          onMouseMove={onMove}
          onMouseUp={onUp}
          onMouseLeave={onUp}
          onTouchStart={onDown}
          onTouchMove={onMove}
          onTouchEnd={onUp}
        >
          <img className="ba-image" src={item.before} alt="Öncesi" />
          <div className="ba-after-wrap" style={{ clipPath: `inset(0 0 0 ${pos}%)` }}>
            <img className="ba-image" src={item.after} alt="Sonrası" />
          </div>
          <div className="ba-label before">ÖNCE</div>
          <div className="ba-label after">SONRA</div>
          <div className="ba-handle" style={{ left: `${pos}%` }} />
        </div>
        <div className="ba-info">
          <div className="ba-info-label">{item.label}</div>
          <div className="ba-info-title">{item.sublabel}</div>
          <div className="ba-info-chip">{item.chip}</div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;
